import { render } from "./AIMLModelling.vue?vue&type=template&id=19978396"
import script from "./AIMLModelling.vue?vue&type=script&lang=js"
export * from "./AIMLModelling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__